<svg class="timeline-active-line" width="3" height="44" viewBox="0 0 3 44" fill="none" xmlns="http://www.w3.org/2000/svg">
  <line opacity="0.5" x1="1.5" y1="1.5" x2="1.5" y2="42.5" stroke="#525252" stroke-width="3" stroke-linecap="round" stroke-dasharray="5 10"/>
  <line x1="1.5" y1="2.5" x2="1.5" y2="10.5" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
</svg>
